import { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import {
    Grid,
    Typography,
    Container,
    Paper,
    Divider
} from "@mui/material";
import { Button } from "@gpstrackit/react-controls"

//Views
import CreateEditSimProvider from 'Modules/simProviders/views/.components/createEditSimProvider';
import DeleteSimProvider from 'Modules/simProviders/views/.components/deleteSimProvider';
import DataView from 'Components/DataView';

//Security
import { HasPermission } from "Core/security";

//Actions
import { simProviderCreateEditOpenModal, simProviderDeleteOpenModal } from 'Redux/actions'

const SimProviderMain = (props) => {
    const { messages } = useIntl();
    const tableRef = useRef();
    const dispatch = useDispatch();

    const user = useSelector(state => state.securityRedux.user);
    const lang = useSelector(state => state.commonRedux.language);
    const deleteSimProviderOpenModal = useSelector(state => state.deleteSimProviderRedux.openModal);
    const createEditSimProviderOpenModal = useSelector(state => state.createEditSimProviderRedux.openModal);

    const [columns, setColumns] = useState([
        {
            key: "id",
            title: messages['sim_providers_main_id'],
            width: 25,
            show: true,
            sort: true,
            locked: true,
            resize: true,
            export: true,
            functionString: 'return row?.id',
            code: "sim_providers_main_id",
            render: (item) => {
                return <span>{item?.id}</span>
            }
        },
        {
            key: "name",
            field: "name",
            title: messages['sim_providers_main_name'],
            show: true,
            sort: true,
            locked: false,
            resize: true,
            export: true,
            functionString: 'return row?.name',
            code: "sim_providers_main_name",
            render: (item) => {
                return <span>{item?.name}</span>
            }
        }
    ])

    const [total, setTotal] = useState(0);

    return (
        <Container maxWidth={false} className="container-view">
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8", height: '95v' }}
                >
                    <Grid item xs={6}>
                        <Typography variant="h5" gutterBottom component="div">
                            {messages['sim_providers_main_title']} ({total})
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className="main-view-buttons">
                        <Button
                            disabled={!HasPermission(user, "simp", "c")}
                            className="btn-dark-blue"
                            onClick={(e) => dispatch(simProviderCreateEditOpenModal(true))}
                        >
                            {messages['sim_providers_add']}
                        </Button>
                    </Grid>
                    <div style={{ width: '100%', marginBottom: 10, marginTop: 5 }}>
                        <Divider style={{ backgroundColor: '#999999' }} />
                    </div>
                    <DataView
                        ref={tableRef}
                        exportName="simproviders"
                        dinamicQuery
                        name="sim-providers-test1"
                        entity="sim-provider"
                        graphqlFunction="searchSimProviders"
                        graphqlSort="SimProviderSortInput"
                        graphqlConditions="SimProviderSearchInput"
                        customQuery="id name"
                        columns={columns}
                        hideAllInPagination
                        asyncSelect
                        searchConditions={["name"]}
                        searchOptionValue="id"
                        searchOptionLabel="name"
                        onChangeConditions={(tags, conditions, total, newColumns, rows, sort) => {
                            let currentConditions = {}
                            let currentTags = {}
                            if (!conditions && tags) {
                                currentConditions = tableRef?.current?.conditions;
                                currentTags = tags;
                            } else {
                                currentConditions = conditions || [];
                                currentTags = currentConditions?.filter((x) => x?.tags)[0]?.tags || [];
                                if (currentTags && currentTags.length > 0) tableRef?.current?.setTags(currentTags);
                            }

                            currentConditions = currentConditions?.filter((item) => item?.fields[0] !== 'id' && item?.fields[0] !== 'name');

                            let tagsById = currentTags.filter((item) => typeof item.id === "number");
                            if (tagsById?.length > 0) {
                                //New Items
                                let currentIds = tagsById.map((item) => (item.id));
                                if (currentIds.length > 0) {
                                    currentConditions.push({ fields: ["id"], terms: currentIds, exact: true, tags: currentTags, conditionOperator: "OR" });
                                }
                            }
                            let tagsByLabel = currentTags.filter(item => typeof item.id === "string")
                            if (tagsByLabel.length > 0) {
                                let currentLabels = tagsByLabel.map((item) => (item.name))
                                if (currentLabels.length > 0) {
                                    currentConditions.push({ fields: ["name"], terms: currentLabels, exact: false, tags: currentTags, conditionOperator: "OR" })
                                }
                            }

                            if (!conditions && tags) tableRef?.current?.getData(null, null, null, currentConditions, newColumns);
                            else tableRef?.current?.getData(null, rows, sort, currentConditions);
                        }}
                        searchFields={["name"]}
                        topheight={200}
                        onChangeTotal={(total) => setTotal(total)}
                        noSplit
                        onChangeColumns={(items) => setColumns(items)}
                        tableButtons={["export", 'orderColumn']}
                        noFilters
                        options={[
                            {
                                id: "edit-sim-provider",
                                label: messages['edit'],
                                single: true,
                                show: true,
                                disabled: !HasPermission(user, "simp", "u"),
                                action: (items) => {
                                    dispatch(simProviderCreateEditOpenModal(true, items[0]))
                                }
                            },
                            {
                                id: "delete-sim-provider",
                                label: messages['delete'],
                                single: true,
                                show: true,
                                disabled: !HasPermission(user, "simp", "d"),
                                action: (items) => {
                                    dispatch(simProviderDeleteOpenModal(true, items[0]))
                                }
                            }
                        ]}
                        onClickMenu={(event, item) => {
                            if (event === messages['edit']) {
                                if (HasPermission(user, "simp", "u")) {
                                    dispatch(simProviderCreateEditOpenModal(true, item))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['sim_provider_edit_title'],
                                        5000,
                                    );
                                }
                            }
                            if (event === messages['delete']) {
                                if (HasPermission(user, "simp", "d")) {
                                    dispatch(simProviderDeleteOpenModal(true, item))
                                } else {
                                    NotificationManager.warning(
                                        messages['common_error_permission'],
                                        messages['sim_provider_delete_title'],
                                        5000,
                                    );
                                }
                            }
                        }}
                        menuOptions={() => {
                            return [
                                messages['edit'],
                                messages['delete']
                            ]
                        }}
                    />
                </Grid>
            </Paper>
            {createEditSimProviderOpenModal && <CreateEditSimProvider tableRef={tableRef} />}
            {deleteSimProviderOpenModal && <DeleteSimProvider tableRef={tableRef} />}
        </Container>
    )
}
export default SimProviderMain;